export const MARKETPLACE = {
  path: 'marketplace',
  data: {
    breadcrumb: 'MENU_ADMIN.MARKETPLACE_PROVIDERS',
    icon: 'pi pi-shopping-cart',
    clickable: false,
    openTab: true
  },
  alliedServices: {
    path: 'allied-services',
    data: {
      breadcrumb: 'MENU_ADMIN.MARKETPLACE_PROVIDERS_SUB.ALLIED_SERVICES_COMMUNITY_PURCHASES',
      icon: 'pi pi-users',
      openTab: true
    }
  },
  suppliers: {
    path: 'suppliers',
    data: {
      breadcrumb: 'MENU_ADMIN.MARKETPLACE_PROVIDERS_SUB.SUPPLIERS',
      icon: 'pi pi-building',
      openTab: true
    }
  },
  quotations: {
    path: 'quotations',
    data: {
      breadcrumb: 'MENU_ADMIN.MARKETPLACE_PROVIDERS_SUB.QUOTATIONS',
      icon: 'pi pi-file-edit',
      openTab: true
    }
  },
  contractsPayments: {
    path: 'contracts',
    data: {
      breadcrumb: 'MENU_ADMIN.MARKETPLACE_PROVIDERS_SUB.CONTRACTS_PAYMENTS',
      icon: 'pi pi-file-contract',
      openTab: true
    }
  }
};

